import { render, staticRenderFns } from "./PerfilFiltros.vue?vue&type=template&id=d97cba3e&scoped=true"
import script from "./PerfilFiltros.vue?vue&type=script&lang=js"
export * from "./PerfilFiltros.vue?vue&type=script&lang=js"
import style0 from "./PerfilFiltros.vue?vue&type=style&index=0&id=d97cba3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97cba3e",
  null
  
)

export default component.exports